import DutchiePaySignup from 'src/payments/dutchie-pay/signup/index';

export default DutchiePaySignup;
